import Alert from "@mui/material/Alert";
import React from "react";
import {
  ABSENCES_PRICING_SECTION,
  AGENDA_PRICING_SECTION,
} from "../../../util/constants";
import PriceCalculator from "../../../components/PriceCalculator";
import { PriceCalculatorInput } from "../../../components/PriceCalculator/tools";
import PricingSection from "../../../components/PricingSection";
import { AbsencesPriceRangeInfos } from "../../../util/types";
import { getAbsencesGlobalPrice, getPriceRangeInfos } from "./fp";
import { Stack } from "@mui/material";

const renderDetailedResult = (
  ranges: AbsencesPriceRangeInfos[] | null,
  input: PriceCalculatorInput,
  classes: {
    alert: string;
    bold: string;
  }
) => {
  if (!ranges) return null;

  const result = getAbsencesGlobalPrice(ranges);

  return (
    <Alert variant="outlined" severity="info" className={classes.alert}>
      Le montant de l'abonnement mensuel Innovance Absences pour{" "}
      <span className={classes.bold}>
        {input.value} salarié{input.value! > 1 ? "s" : null}
      </span>{" "}
      sera de : <span className={classes.bold}>{result} € HT</span>
      <ul>
        {ranges.map((range) => (
          <li key={`range-from-${range.start}-to-${range.end}`}>
            <p>
              {range.text}{" "}
              {!range.unitPrice
                ? null
                : `(${range.count} salarié${range.count! > 1 ? "s" : ""} x ${
                    range.unitPrice
                  } €) `}
              : <span className={classes.bold}>{range.totalPrice} € HT</span>
            </p>
          </li>
        ))}
      </ul>
    </Alert>
  );
};

const AbsencesPricings = () => (
  <PricingSection
    product="Absences"
    sectionId={ABSENCES_PRICING_SECTION}
    priceFileName="innovance-solutions-fiche-tarifs.pdf"
    productFileName="innovance-absences-fiche-produit.pdf"
    CalculatorComponent={
      <>
        <PriceCalculator
          mode="mensuel"
          fieldLabel="Nombre de salariés"
          getPriceRangeInfos={getPriceRangeInfos}
          renderDetailedResult={renderDetailedResult}
        />
        <Stack alignItems="center">
          NB : le nombre d'utilisateurs Innovance Absences facturés sera
          strictement identique au nombre d'utilisateurs Innovance Agenda
          facturés.
        </Stack>
      </>
    }
  />
);

export default AbsencesPricings;
